import Vuex from 'vuex'
import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate';
import SecureLS from "secure-ls";
const ls = new SecureLS({ isCompression: false });

import * as mutations from './mutations';
import * as actions from './actions';
import * as states from './states';
import astec  from './modules/astec';

Vue.use(Vuex);

export default new Vuex.Store({
  state: states.estado,
  plugins: [
    createPersistedState({
      storage: {
        getItem: key => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: key => ls.remove(key)
      }
    })
  ],
  modules: {
    astec
  },
  mutations,
  actions,
  getters: states.getters
})
